import { Decimal } from '~/composables/support/decimal'
import type { ContractPropertyInput } from '~/resources/graphql/graphql'

export type QuestionFormData = {
    contractQuestions: ContractQuestionFormData[]
    enrollmentQuestions: EnrollmentQuestionFormData[]
}

export type QuestionValue = {
    propertyValue: string
    planQuestionOptionIds: string[]
    // Whether the input for the question is invalid
    invalid: boolean
}

export type ContractQuestionFormData = {
    planQuestion:
        | PlanQuestionBaseSpec
        | PlanQuestionNumberSpec
        | PlanQuestionTextSpec
        | PlanQuestionParagraphSpec
        | PlanQuestionSingleChoiceSpec
    planQuestionOptions: PlanQuestionOptionSpec[]
    propertyValue: string
    planQuestionOptionIds: string[]
    required: boolean
    // Whether the input for the question is invalid
    invalid: boolean
}

export type EnrollmentQuestionFormData = {
    questions: ContractQuestionFormData[]
    enrollmentSpecification: {
        enrollmentTypeName: string
        enrollmentTypeId: string
        sequence: number
    }
    enrollment?: {
        customerName: string
    }
}

type QuestionBase = {
    id: string
    questionTitle: string
    questionBody: string
}

export type PlanQuestionOptionSpec = {
    id: string
    label: string
    pricing?: QuestionPricingConfig
}

export type PlanQuestionBaseSpec = QuestionBase & {
    questionType:
        | 'PlanBooleanQuestion'
        | 'PlanMultipleChoiceQuestion'
        | 'PlanPhoneNumberQuestion'
        | 'PlanEmailQuestion'
}

export type PlanQuestionNumberSpec = QuestionBase & {
    questionType: 'PlanNumberQuestion'
    numberConfig: {
        pricing: QuestionPricingConfig | null
        min: number | null
        max: number | null
    }
}

export type PlanQuestionTextSpec = QuestionBase & {
    questionType: 'PlanTextQuestion'
    size: string
}

export type PlanQuestionParagraphSpec = QuestionBase & {
    questionType: 'PlanParagraphQuestion'
    size: string
}

export type PlanQuestionSingleChoiceSpec = QuestionBase & {
    questionType: 'PlanSingleChoiceQuestion'
    questionInputType: string
    size: string
}

export type QuestionPricingConfig = {
    feePricingTotal: Decimal
    duesPricingTotal: Decimal
}

export function convertQuestionToProperty(
    question: ContractQuestionFormData
): ContractPropertyInput {
    let options = null
    if (
        question.planQuestion.questionType === 'PlanMultipleChoiceQuestion' ||
        question.planQuestion.questionType === 'PlanSingleChoiceQuestion'
    ) {
        options = question.planQuestionOptionIds
    }

    return {
        contractPropertyId: null,
        enrollmentId: null,
        enrollmentSpecification: null,
        planQuestionId: question.planQuestion.id,
        originalQuestionText: question.planQuestion.questionTitle,
        propertyValue: question.propertyValue,
        planQuestionOptionIds: options
    }
}
